module.exports = __webpack_public_path__ + "img/fi-rr-print.2dcdb4bb.svg";